// 泰文
export default {
    dialog: {
        msgShow: "การแจ้งเตือน",
        buttonOk: 'ตกลง',
        buttonCancel: 'ยกเลิก',
    },
    photoBrowser: {
        bannerPhotoBrowser: 'ปิด'
    },
    employeeNumber: 'รหัสช่าง',
    pleaseEnterEmployeeNumber: 'ป้อนรหัสช่างเทคนิค',
    password: 'รหัสผ่าน',
    pleaseEnterPassword: 'ใส่รหัสผ่าน',
    login: 'เข้าสู่ระบบ',
    required: 'ที่จำเป็น',
    synchronize: 'ซิงค์.',
    salesOrder: 'รายงานการบริการ',
    pleaseEnterHome: 'กรอกชื่อลูกค้าและรายงานการบริการ',
    searchFilter: 'ค้นหาและกรอง',
    machineSpecifications: 'รุ่นและข้อมูลจำเพาะ',
    processingStatus: 'สถานะของกิจการ',
    processing: null,
    finish: 'สมบูรณ์',
    waitCountermeasures: 'รอซ่อม.',
    reset: 'กลับ',
    submit: 'ส่งแล้ว',
    muMachineInvestigation: 'การใช้เครื่องจักร',
    logout: 'ออกจากระบบ',
    searchDate: 'ค้นหาวันที่',
    time: 'เวลาค้นหา',
    basicInformation: 'ข้อมูลลูกค้า',
    addSalesOrder: 'เพิ่มรายงานการบริการ',
    save: 'บันทึก',
    date: 'วันที่',
    pleaseSelectDate: 'เลือกวันที่',
    travelNumber: 'ไฟล์รายงานการบริการ',
    pleaseEnterTravelNumber: 'กรอกหมายเลขไฟล์รายงานการบริการ',
    customerCode: 'รหัสลูกค้า',
    pleaseEnterCustomerCode: 'กรอกรหัสลูกค้า',
    customerName: 'ชื่อลูกค้า',
    pleaseEnterCustomerName: 'กรอกชื่อลูกค้า',
    country: 'พื้นที่ประเทศ',
    pleaseEnterCountry: 'เข้าสู่พื้นที่ประเทศ',
    customerAddress: 'ที่อยู่ลูกค้า',
    pleaseEnterAddress: 'กรอกที่อยู่ลูกค้า',
    customerContact: 'บุคคลที่ติดต่อลูกค้า',
    pleaseEnterContact: 'ป้อนผู้ติดต่อของลูกค้า',
    salesRepresentative: 'ตัวแทนฝ่ายขาย',
    pleaseEnterSalesRepresentative: 'กรุณากรอกตัวแทนฝ่ายขาย',
    hint: 'การแจ้งเตือน',
    createDate: 'ตั้งวันที่',
    salesOrderNumber: 'รายงานเลขที่ไฟล์',
    customerSatisfaction: 'ความพึงพอใจของลูกค้า',
    maintenancePersonnel: 'ช่าง',
    maintenanceTime: 'เวลาให้บริการ',
    customerConfirmation: 'ลูกค้ายืนยัน',
    copy: 'คัดลอก',
    delete: 'ลบ',
    recordTime: 'บันทึกเวลา',
    machineNumber: 'หมายเลขเครื่อง',
    copyToSalesOrder: 'คัดลอกเข้ามา',
    copyTo: 'คัดลอกไปที่',
    selectSalesOrderNumber: 'เลือกไฟล์รายงานการบริการ',
    pleaseEnterSalesOrderNumber: 'กรอกไฟล์รายงานการบริการเลขที่',
    latitudeAndLongitude: 'ละติจูดและลองจิจูด',
    startMaintenance: 'เริ่มให้บริการ',
    endMaintenance: 'สิ้นสุดการบริการ',
    newMachine: 'รายงานการติดตั้ง',
    maintenance: 'ซ่อมเครื่อง',
    addMachineServiceOrder: 'เพิ่มไฟล์รายงานการบริการเครื่องจักร',
    selectType: 'เลือกประเภท',
    generalMaintenance: 'ซ่อมเครื่อง',
    oilEducationTraining: 'การฝึกอบรมน้ำมัน',
    pleaseEnterMachineNumber: 'ใส่หมายเลขเครื่อง',
    manufacturingDate: 'วันที่ผลิต',
    pleaseSelectManufacturingDate: 'เลือกวันที่ผลิต',
    maintenanceWarranty: 'บริการในการรับประกัน (หนึ่งปี)',
    underWarranty: 'บริการในระยะรับประกัน',
    warrantyExpired: 'การรับประกันหมดอายุแล้ว',
    confirm: 'ตกลง',
    cancel: 'ยกเลิก',
    addMaintenancePersonnel: 'กรอกชื่อช่างเทคนิค',
    maintenanceTimeTotal: 'ระยะเวลาให้บริการทั้งหมด',
    day: 'วัน',
    hour: 'ชั่วโมง',
    enterFactory: 'เริ่มให้บริการ',
    pleaseSelectEnterFactory: 'เลือกเริ่มบริการ',
    longitude: 'ลองจิจูด',
    // pleaseEnterLongitude: 'กรุณากรอกละติจูด',
    latitude: 'ละติจูด',
    // pleaseEnterLatitude: 'กรุณากรอกลองจิจูด',
    leaveFactory: 'จบการบริการ',
    pleaseSelectLeaveFactory: 'กรุณาเลือกบริการเสร็จสิ้น',
    duration: 'เวลาให้บริการ',
    pleaseEnter: 'กรุณาเข้า',
    selectTime: 'เลือกวันที่และเวลา เลือก',
    selectSatisfaction: 'ความพึงพอใจของลูกค้า',
    verySatisfied: 'พึงพอใจมาก',
    satisfied: 'พอใจ',
    ordinary: 'สามัญ',
    dissatisfied: 'ความไม่พอใจ',
    veryDissatisfied: 'ไม่พอใจอย่างมาก',
    opinionReply: 'ความคิดเห็นของลูกค้า',
    takePhoto: 'ถ่ายภาพ',
    uploadFile: 'อัพโหลดไฟล์',
    audio: 'ไฟล์เสียง',
    video: 'ไฟล์วิดีโอ',
    electronicSignature: 'ลายเซ็นของลูกค้า',
    signatureDate: 'วันที่ลงนาม',
    clear: 'ลบ',
    machineInformation: 'ข้อมูลเครื่อง',
    machineFunction: 'การตรวจสอบเครื่องจักร',
    organizationArrangement: 'โครงสร้างและรูปแบบ',
    spareParts: 'อะไหล่',
    operationProcedure: 'บันทึกการทดสอบ',
    problemHandling: 'กระบวนการ',
    trainee: 'เด็กฝึกงาน',
    coursePlan: 'แผนหลักสูตร',
    courseSchedule: 'ตารางเรียน',
    inputVoltageAndCurrent: 'ป้อนแรงดันไฟฟ้า/แอมแปร์',
    lowSpeed: 'ความเร็วช้า',
    highSpeed: 'ความเร็วสูง',
    accelerationDecelerationSlope: 'บัญชี/ธ.ค. ทางลาด',
    acceleration: 'บัญชี ทางลาด',
    deceleration: 'ทางลาดธ.ค',
    clothRoller: 'ใช้เวลาขึ้น',
    left: 'ซ้าย',
    center: 'กลาง',
    right: 'ขวา',
    yarnFeedingTeeth: 'เกียร์/ลูกรอกคุณภาพ',
    saddleRingDistance: 'อ. แหวนยึดกล้องและเฟรม',
    yarnNozzleNumber: 'ผู้ให้บริการเส้นด้าย',
    height: 'ความสูง',
    spacing: 'ช่องว่าง',
    warpYarnInfo: 'ผ้าสีเทา',
    inch: 'นิ้ว',
    cm: 'เซนติเมตร',
    timeSequence: 'จังหวะ',
    needle: 'เข็ม',
    yarnSpecification: 'ข้อกำหนดเส้นด้าย',
    yarn: 'เส้นด้าย',
    serialNumber: 'หมายเลขเครื่องอื่นๆ',
    technician: 'ช่าง',
    series: 'ชุดผ้า',
    fabricType: 'ประเภทผ้า',
    productFeatures: 'คุณสมบัติของสินค้า',
    inputVoltage: 'ป้อนแรงดันไฟฟ้า',
    inputCurrent: 'ป้อนแอมแปร์',
    electronicWindingTensionUpper: 'ไฟฟ้า. ลูกกลิ้งแอมแปร์ (บน)',
    electronicWindingTensionLower: 'ไฟฟ้า. แอมแปร์ลูกกลิ้ง (ล่าง)',
    mechanicalType: 'เครื่องจักร เกียร์ลูกกลิ้ง',
    lowerNeedleDistanceToSeatRing: 'โรค แหวนยึดกระบอกสูบและลูกเบี้ยว',
    upperNeedleDistanceToSeatRing: 'โรค แหวนยึดหน้าปัดและลูกเบี้ยว',
    upperNeedleDistanceToLowerNeedleNozzle: 'แป้นหมุนช่องว่างและกระบอกสูบกระแทกที่ขอบ',
    selectorNeedleRingDistanceToTakeUpPlate: 'โรค ระหว่างวงแหวนแอคชูเอเตอร์และเฟรม',
    seatRingDistanceToTakeUpPlate: 'โรค ระหว่างวงแหวนยึดลูกเบี้ยวและเฟรม',
    machineSpeed: 'รอบต่อนาที',
    inverterFrequency: 'อินเวอร์เตอร์ HZ',
    yarnCount: 'ดัชนีราคาผู้บริโภค',
    gramsPerSquareMeter: 'จีเอสเอ็ม',
    yardsPerPound: 'ก/ย',
    customerYarnWidth: 'ความกว้าง',
    customerSpecifiedYarnLength: 'กำหนดความยาวของตะเข็บ',
    newCustomerPackageTiming: 'จังหวะซิงเกอร์',
    doubleSidedCuttingTiming: 'ไดอัลแคมไทม์มิ่ง',
    nozzleTiming: 'ไทม์มิ่งผู้ให้บริการเส้นด้าย',
    yarnCode: 'รหัสเส้นด้าย',
    yarnType: 'ข้อมูลจำเพาะเส้นด้าย',
    color: 'สี',
    yarnSize: 'จำนวนเส้นด้าย',
    fiberCount: 'เส้นใย',
    innerFiber: 'กองเข้ามา',
    outerFiber: 'กองออกมา',
    flatness: 'ระดับ',
    roundness: 'ความกลม',
    windPressure: 'ความกดอากาศ',
    appearance: 'รูปร่าง',
    machineLevel: 'ความเรียบของโครงเครื่อง',
    trident: 'ความเรียบและความกลมของหน้าปัด',
    highLegWinder: 'ขาสูงรับ',
    fabricSlitting: 'เปิดกว้างขึ้น',
    inverterCurrent: 'อินเวอร์เตอร์แอมแปร์',
    machineFunctionFrame: 'เส้นด้าย MPF และแหวนและ Creels',
    inchStart: 'Jog เริ่มและหยุดสวิตช์ฟังก์ชั่น',
    firstSecondSpeed: 'ฟังก์ชั่นสวิตช์ความเร็ว หลอดไฟ และพัดลม',
    firstSecondSpeed2: 'ฟังก์ชั่นการตั้งค่าความเร็ว',
    controllerOtherFunctions: 'ฟังก์ชั่นอื่นๆ ของตัวควบคุม',
    electricalBoxSignals: 'สัญญาณและเซ็นเซอร์',
    fanDustRemovalAction: 'การทำงานของพัดลม',
    oilSprayerAction: 'การทำงานของออยเลอร์',
    airBlowerSystemAction: 'ความกดอากาศและการทำงาน',
    windingAction: 'รับระบบ. การดำเนินการ',
    machineControllerOperationTutorial: 'การฝึกอบรมการทำงานของแผงควบคุม',
    machineOperationTutorial: 'การฝึกอบรมการปฏิบัติงาน M/C',
    other: 'คนอื่น',
    descriptionAndAttachment: 'อ้างอิง',
    upperNeedleArrangement: 'เข็มหมุนสั่ง',
    upperKnifeArrangement: 'สั่งมีดกด',
    lowerNeedleArrangement: 'สั่งเข็มกระบอก',
    lowerNeedleArrangementShort: 'สั่งเข็มกระบอก',
    lowerKnifeArrangement: 'สั่งมีดกระบอก',
    lowerKnifeArrangementShort: 'สั่งมีดกระบอก',
    upperNeedlePlate: 'กดหมายเลข',
    lowerNeedleCylinder: 'กระบอก',
    blank: 'ช่องว่าง',
    blockRule: 'วัดจิ๊ก',
    retractionBaseline: 'เขตจมเกอร์ กลับ',
    upperPlateNeedleWithdrawalKnob: 'ปุ่มหมุนสเกล',
    upperPlateNeedleWithdrawalDepth: 'ระยะห่างของตะเข็บหน้าปัด',
    upperPlateHalfNeedleHeight: 'หน้าปัดถัก, เหน็บ dist.',
    upperPlateFlatNeedleHeight: 'กดหมายเลข miss cam dist',
    lowerCylinderFlatNeedleHeight: 'กระบอกลูกเบี้ยวขาด',
    lowerCylinderFlatNeedleDepth: 'dist ตะเข็บกระบอก',
    lowerCylinderNeedleWithdrawalKnob: 'ลูกบิดขนาดกระบอกสูบ',
    yarnTypeCode: 'รหัสเส้นด้าย',
    yarnTypeTensionN: 'ความตึงเส้นด้าย (N)',
    cmPer100Needles: 'ความยาวตะเข็บ / 100N',
    feedYarnLengthPerRevolution: 'ความยาวตะเข็บ / 1 คอร์ส',
    aluminumPlateYarnFeedingDepthCm: 'รอกคุณภาพขนาดเส้นผ่านศูนย์กลาง (ซม.)',
    yarnFeedingAluminumPlateScale: 'เครื่องหมายลูกรอกคุณภาพ',
    newCustomerPackage: 'จม',
    upperPlate: 'กดหมายเลข',
    lowerCylinder: 'กระบอก',
    yarnShort: 'เส้นด้าย',
    pleaseEnterProductName: 'ป้อนคำอธิบายชิ้นส่วน',
    pleaseEnterProductNumber: 'กรอกหมายเลขชิ้นส่วน',
    quantity: 'ปริมาณ',
    damage: 'แตกหัก',
    missing: 'หายไป',
    wrong: 'ผิด',
    pleaseEnterTitle: 'ป้อนชื่อ',
    pleaseEnterContent: 'ป้อนเนื้อหา',
    addQuestionItem: 'เพิ่มรายการคำถาม',
    questionProcessingRecord: 'บันทึกมาตรการตอบโต้',
    pleaseEnterQuestionDescription: 'ป้อนคำอธิบายปัญหา',
    traineeAndClient: 'ผู้ฝึกงาน/ลูกค้า',
    trainer: 'เทรนเนอร์',
    drawingFunction: 'ฟังก์ชั่น CAD',
    upperMachineProgram: 'โปรแกรมเครื่อง',
    UnravelingFunction: 'การวิเคราะห์ผ้า',
    courseName: 'ชื่อหลักสูตร',
    pleaseEnterCourseName: 'กรอกชื่อหลักสูตร',
    imageName: 'ชื่อไฟล์รูปแบบ',
    pleaseEnterImageName: 'ป้อนชื่อไฟล์รูปแบบ',
    confirmItem: 'ยืนยัน',
    undone: 'ไม่สมบูรณ์',
    pleaseEnterInquire: 'กรอกชื่อลูกค้า เอกสาร MU',
    machineUtilizationSurvey: 'การใช้เครื่องจักร',
    customerID: 'รหัสลูกค้า',
    pleaseEnterCustomerID: 'ป้อนรหัสลูกค้า',
    pleaseSelect: 'เลือก',
    pleaseEnterSkill: 'เข้าสกิล',
    pleaseEnterBuyer: 'ป้อนผู้ซื้อ',
    pleaseEnterRemark: 'ใส่หมายเหตุ',
    source: 'แหล่งที่มา',
    selfInput: '自行輸入',
    textileEquipment: 'เครื่องถัก',
    textileMachineBrand: 'ยี่ห้อเครื่องถัก',
    textileMachineType: 'เครื่องถักรุ่น',
    notSelected: 'เลือกยังไม่ได้',
    select: 'เลือก',
    brand: 'ยี่ห้อ',
    totalMachine: null,
    openRate: null,
    dailyOutput: null,
    spinning: '紡紗',
    knitting: '針織',
    dyeing: '染整',
    garment: '成衣',
    pleaseEnterProcessingContent: 'กรุณากรอกเนื้อหาการปรับ',
    // alert
    editNotSave: 'การแก้ไขยังไม่ได้รับการบันทึก คุณแน่ใจหรือว่าจะออก?',
    deleteConfirm: 'คุณแน่ใจหรือว่าจะลบ?',
    confirmClearSignature: 'คุณแน่ใจหรือว่าจะลบข้อมูลที่เกี่ยวข้องกับลายเซ็น?',
    confirmWriteData: 'คุณแน่ใจหรือว่าเขียนลงในข้อมูล?',
    confirmCopyToSalesOrder: 'คุณแน่ใจหรือว่าคัดลอกข้อมูลไปยังรายงานบริการนี้',
    fieldsNotFilledUnableToSend: '尚有欄位未填寫，無法送出。',
    dataWriteComplete: '資料寫入完成。',
    deleteSuccess: 'ลบสำเร็จ',
    clearSuccess: 'ลบสำเร็จ',
    copySuccess: 'คัดลอกสำเร็จ',
    selectWorker: 'กรุณาเลือกช่างเทคนิค',
    selectProblem: 'กรุณาเลือกรายการคำถาม',
    unknownError: 'An unknown error has occurred, please contact customer service.',
    fileTypeError: 'File type mismatch',
    openCameraPermission: 'Please grant camera access first.',
    //new
    selectDate: 'เลือกวันที่',
    yarnTensionN: 'ความตึงเส้นด้าย (N)',
    category: 'พิมพ์',
    kind: 'แบบอย่าง',
    // pleaseSelectType: 'เลือกประเภท',
    dateInOutError: 'วันที่เข้ารับบริการเสร็จสิ้นจะต้องเท่ากับหรือช้ากว่าวันที่เริ่มรับบริการเสมอ',
    yarnFeedingTeethOrDisc: 'เกียร์/ลูกรอกคุณภาพ',
    changed: 'เปลี่ยน',
    pleaseSelectSparePartsStatus: 'โปรดเลือกสถานะอุปกรณ์เสริม',
    pleaseEnterDuration: null,

    // API語系
    saveComplete: 'บันทึกสำเร็จ。',
    needOnline: 'Need Online.',
    addComplete: 'เพิ่มสำเร็จ。',
    reportCreator: 'ผู้สร้างรายงาน',
    onlineGenerate: 'Generate after uploading',
    synchronizeFail: 'Synchronize Fail.',
    synchronizeSuccess: 'ซิงโครไนซ์สำเร็จ',
    downloadFail: 'Download Fail.',
    downloadSuccess: 'ดาวน์โหลดสำเร็จ',
    synchronizeSelect: 'ซิงโครไนซ์เลือก',
    onlySynchronizeOffData: 'กำลังดาวน์โหลดข้อมูลออนไลน์',
    synchronizeData: 'กำลังซิงค์ข้อมูลออฟไลน์',
    synchronizeImage: 'ซิงโครไนซ์รูปภาพ',
    downloadOfflineFile: 'Download OffLine File',
    downloadOfflineData: 'ดาวน์โหลดข้อมูลออฟไลน์',
    downloadOfflineImage: 'ดาวน์โหลดภาพออฟไลน์',
    synchronizing: 'กำลังซิงโครไนซ์ โปรดรอสักครู่ อย่าปิดหน้าจอแอป',
    downloading: 'กำลังดาวน์โหลด โปรดรอสักครู่ อย่าปิดหน้าจอแอป',
    confirmDownload: 'คุณยืนยันการดาวน์โหลดหรือไม่？',
    confirmSynchronization: 'คุณยืนยันการซิงโครไนซ์หรือไม่？',
    overwriteOffline : 'การดาวน์โหลดจะเขียนทับข้อมูลออฟไลน์ปัจจุบัน',
    synchronizationOnline: 'การซิงโครไนซ์จะซิงค์ข้อมูลที่เกี่ยวข้องกับออนไลน์',
    uploadFail: 'Upload failed.',
    fileSzieOverTit: 'The file size is too large.',
    fileSzieOverMes: 'Only files under 50 MB can be uploaded. For files over 50 MB, please upload to the wired version.',

    sortByCreate: 'จัดเรียงตามสร้างคำสั่งซื้อ',
    sortByType: 'จัดเรียงตามประเภท',
    reportDownload: 'รายงาน',
    selectServiceReport: 'เลือกรายงานบริการ',
    enterServiceReportOrMachine: 'ป้อนหมายเลขรายงานบริการหรือหมายเลขเครื่อง',
    selectAll: 'เลือกทั้งหมด',

    downloadHint:null
}
